<template>
      <div class="imgShow">
          <div class="imgbox">
              <img
                id="showPic"
                :src="imgsrc"
                width="400px"
                height="300px">
          </div>
      </div>
</template>

<script>
export default {
    name:'ImgShow',
    data(){
        return{
            imgsrc:'./img/show000.png',
            imgShowNum:0,
            imglist:[
                './img/show001.png',
                './img/show002.png',
                './img/show003.png',
                './img/show004.png',
                './img/show005.png',
            ],
            changeTime:5000,
        }
    },
    methods:{
        imgChange(){
            this.imgsrc=(this.imglist[this.imgShowNum])
            console.log(this.imgShowNum)
            if(this.imgShowNum<this.imglist.length){
                this.imgShowNum++
            }
            if(this.imgShowNum>=this.imglist.length){
                this.imgShowNum=0
            }
        },

    },
    mounted:function(){
        this.$nextTick(function(){
            setInterval(this.imgChange,this.changeTime);
        })
    },
}
</script>

<style>
    .imgShow{
        width: 400px;
        height: 300px;
        overflow:hidden;
        border-radius: 0.5em;
    }
    .imgbox{
        position:relative;
        animation:switch 5s infinite;
    }
    @keyframes switch{
        0%   {left:405px;}
        5%   {left:405px;}
        50%  {left:0px;}
        95%   {left:405px;}
        100%  {left:405px}
    }
    .imgbox img{
        border-radius: 0.5em;
    }
</style>